import React from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import { IMatch } from "../../types";
import Link from "../link";
import { injectIntl } from "react-intl";
import messages from "./PageViewMatch.intl";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      justifyContent: "center",
      flexWrap: "wrap",
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    paper: {
      padding: theme.spacing(1.5, 2.5),
      background: "rgba(255, 255, 255, 0.1)",
      border: "1px solid rgba(255, 255, 255, 0.2)",
      borderRadius: "12px",
    },
  })
);

const Breadcrumb = injectIntl<{ match: IMatch }>(({ match, intl }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Paper elevation={0} className={classes.paper}>
        <Breadcrumbs 
          aria-label="breadcrumb"
          style={{ 
            color: "rgba(255, 255, 255, 0.95)",
          }}
        >
          <Link 
            color="inherit" 
            to="/"
            style={{ 
              color: "rgba(255, 255, 255, 0.85)",
              textDecoration: "none",
              transition: "color 0.3s ease",
            }}
          >
            {intl.formatMessage(messages.team)}
          </Link>
          <Link 
            color="inherit" 
            to="/people/matches"
            style={{ 
              color: "rgba(255, 255, 255, 0.85)",
              textDecoration: "none",
              transition: "color 0.3s ease",
            }}
          >
            {intl.formatMessage(messages.matches)}
          </Link>
          <Typography 
            style={{ 
              color: "white",
              fontWeight: 600,
            }}
          >
            {match.homeTeam.name} vs {match.awayTeam}
          </Typography>
        </Breadcrumbs>
      </Paper>
    </div>
  );
});

export default Breadcrumb;
